import { Button } from '@material-ui/core'
import React from 'react'
import { useDispatch } from 'react-redux'
import { login } from './features/userSlice'
import { auth, provider } from './firebase'
import "./Login.css"

function Login() {
    const dispatch = useDispatch();
    const signIn = () => {
        auth.signInWithPopup(provider)
        .then(({user}) => {
            dispatch(
                login({
                displayName:user.displayName,
                email:user.email,
                photoUrl:user.photoURL

            }))
        })
        .catch((error) => alert(error.message));
        
    }
    return (
        <div className="login">
            <div className="login__container">
                <img src="https://s3.amazonaws.com/images.seroundtable.com/new-google-logo-animated-1441195158.gif" alt="" />
                <Button variant="contained" color="primary" onClick={signIn}>
                    Login
                    </Button>
            </div>
        </div>
    )
}

export default Login
